module.exports = __webpack_public_path__ + "static/8f49e435-da2a-477b-ae77-99ddc8c34c8d-f2380246beb5a3621c41204e05be5ccc.jpg";